import { useLocation, useParams } from "react-router-dom";
import { EnumOwnerType, Owner } from "../../gql/generated.ts";

/**
 * Returns the type of user we're logged in as
 * @returns
 */
export const useLoggedInAs = (): Owner | null => {
  const location = useLocation();
  const params = useParams();

  if (
    location.pathname.startsWith("/app/organization") &&
    params.organizationId
  ) {
    return {
      type: EnumOwnerType.Organization,
      entityId: params.organizationId,
    };
  } else if (
    location.pathname.startsWith("/app/operator") &&
    params.operatorEntityId
  ) {
    return {
      type: EnumOwnerType.Operator,
      entityId: params.operatorEntityId,
    };
  }
  return null;
};
